module.exports = __webpack_public_path__ + "static/media/entrance-slider.bb9628fe.jpg";